import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function G2Crowd(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#446373" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 11.8161 17.9917 11.6342 17.9755 11.4545L17.4545 11.4545L15.7795 11.4545L13.0909 11.4545V13.6364H15.4507C14.8379 14.9263 13.5231 15.8182 12 15.8182C9.89128 15.8182 8.18182 14.1087 8.18182 12C8.18182 9.89128 9.89128 8.18182 12 8.18182V6ZM13.2088 10.3636H16.1032V9.7901H14.1046L15.1571 8.66371C15.433 8.36413 15.6316 8.09658 15.7528 7.86105C15.874 7.62552 15.9346 7.40035 15.9346 7.18551C15.9346 6.81498 15.8139 6.52476 15.5725 6.31486C15.331 6.10495 15.0014 6 14.5836 6C14.2938 6 14.0381 6.05814 13.8164 6.17443C13.5947 6.29071 13.4242 6.45381 13.3049 6.66371C13.1857 6.87362 13.1261 7.10963 13.1261 7.37177H13.8445C13.8445 7.1254 13.9085 6.93126 14.0366 6.78936C14.1647 6.64745 14.3451 6.5765 14.5777 6.5765C14.7728 6.5765 14.928 6.63957 15.0433 6.76571C15.1586 6.89185 15.2162 7.0574 15.2162 7.26238C15.2162 7.41808 15.1724 7.57329 15.0847 7.72801C14.997 7.88273 14.8496 8.07539 14.6427 8.30599L13.2088 9.86992V10.3636Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

G2Crowd.propTypes = propTypes;
G2Crowd.defaultProps = defaultProps;

export default G2Crowd;
